import React, { useContext } from 'react';
import { Navigate, Route } from "react-router-dom";
import AuthContext from "../Contexts/AuthContext";

const PrivateRoute = ({ element }) => {
    const { isAuthenticated } = useContext(AuthContext);
    return isAuthenticated ? element : <Navigate to="/" />;
}

export default PrivateRoute;
